import avatar from "../assets/avatar-user.png";
import { Header } from "./styles/ChatStyles";

const ChatHeader = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const rawName = searchParams.get("clientName");

  const name = rawName
    ? rawName.replace(/\./g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
    : "Atendente";

  return (
    <Header>
      <img src={avatar} alt="Avatar" />
      <div>
        <strong>{name}</strong>
      </div>
    </Header>
  );
};

export default ChatHeader;
